import { render, staticRenderFns } from "./editCustomer.vue?vue&type=template&id=427c261e&scoped=true&"
import script from "./editCustomer.vue?vue&type=script&lang=js&"
export * from "./editCustomer.vue?vue&type=script&lang=js&"
import style0 from "./editCustomer.vue?vue&type=style&index=0&id=427c261e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c261e",
  null
  
)

export default component.exports